import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  installStaleAppRecovery,
  isStaleAppFailure,
  markAppBooted,
  reloadStaleAppOnce,
} from './utils/reloadStaleApp';

installStaleAppRecovery();

type RecoveryState = { failed: boolean; reloading: boolean };

/** A missing script from the previous deploy used to wipe the page. Reload once instead. */
class StaleAppBoundary extends React.Component<{ children: React.ReactNode }, RecoveryState> {
  state: RecoveryState = { failed: false, reloading: false };

  static getDerivedStateFromError(error: unknown): RecoveryState {
    return { failed: true, reloading: isStaleAppFailure(error) };
  }

  componentDidCatch(error: unknown) {
    if (isStaleAppFailure(error)) reloadStaleAppOnce();
  }

  render() {
    if (!this.state.reloading) return this.state.failed ? null : this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-dark-950 px-6 text-center text-white">
        <p>Loading the latest version…</p>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <StaleAppBoundary>
      <App />
    </StaleAppBoundary>
  </React.StrictMode>
);

markAppBooted();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
